import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import { notificationsBackPlan } from '../notifications/notificationRoutes.js';
export default class NotificationInboxHeader {
  view() {
    const back = () => {
      const history = app.history;
      const plan = notificationsBackPlan({
        canGoBack: !!(history && typeof history.canGoBack === 'function' && history.canGoBack())
      });
      if (plan.type === 'history' && history && typeof history.back === 'function') {
        history.back();
        return;
      }
      if (typeof m !== 'undefined' && m.route) {
        m.route.set(plan.href || '/');
      }
    };
    return m("header", {
      className: "NotificationInboxHeader"
    }, m(Button, {
      className: "Button Button--icon Button--flat App-backControl NotificationInboxHeader-back",
      icon: "fas fa-arrow-left",
      "aria-label": "Back",
      onclick: back
    }), m("h1", {
      className: "NotificationInboxHeader-title App-titleControl App-titleControl--text"
    }, "Notifications"), m("span", {
      className: "App-primaryControl NotificationInboxHeader-bell",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-bell",
      title: "Notifications"
    })));
  }
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/NotificationInboxHeader', NotificationInboxHeader);